import auMap from '@highcharts/map-collection/countries/au/au-all.topo.json';
import gbMap from '@highcharts/map-collection/countries/gb/gb-all.topo.json';
import usMap from '@highcharts/map-collection/countries/us/us-all.topo.json';
import nzMap from '@highcharts/map-collection/countries/nz/nz-all.topo.json';

export const mapPropertiesByCountry = (countryCode) => {
  switch (countryCode) {
    case 'AU':
      return {
        map: auMap,
        projection: 'geoConicConformal',
        projectionConfig: {
          rotate: [0, 0, 97],
          center: [148, 45],
          scale: 1150,
        },
      };
    case 'GB':
      return {
        map: gbMap,
        projection: 'geoAlbers',
        projectionConfig: {
          center: [1, 55.4],
          rotate: [4.4, 0, 0],
          parallels: [50, 60],
          scale: 4000,
        },
      };
    case 'US':
      return {
        map: usMap,
        projection: 'geoAlbersUsa',
        projectionConfig: {
          center: [-96, 40],
          scale: 1100,
        },
      };
    case 'NZ':
      return {
        map: nzMap,
        projection: 'geoConicConformal',
        projectionConfig: {
          rotate: [0, 0, 70],
          center: [139.5, -8],
          scale: 3000,
        },
      };
    default:
      return {};
  }
};
